import React from 'react'
import { Column } from 'src/components/Layout/Styled'
import SingleForm from './SingleForm'

const InformationForm = () => {
  return (
    <Column>
      <SingleForm />
    </Column>
  )
}

export default InformationForm
